
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { applyRealtimeConfig } from '@/utils/realtimeConfig';
import { Loader2, Database } from 'lucide-react';
import RealtimeStatus from './RealtimeStatus';
import { toast } from 'sonner';

interface RealtimeConfigButtonProps {
  variant?: 'default' | 'outline' | 'secondary';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showStatus?: boolean;
}

const RealtimeConfigButton = ({
  variant = 'outline',
  size = 'sm',
  showStatus = true
}: RealtimeConfigButtonProps) => {
  const [isConfiguring, setIsConfiguring] = useState(false);

  const handleApplyConfig = async () => {
    setIsConfiguring(true);
    try {
      const result = await applyRealtimeConfig(); 
      
      if (result.success) {
        console.log('Realtime configuration applied successfully');
        toast.success('Realtime configuration updated successfully');
      } else {
        console.error(`Failed to apply realtime config: ${result.message}`);
        toast.error('Failed to update realtime configuration');
      }
    } catch (error) {
      console.error('Error applying config:', error);
      toast.error('Error applying realtime configuration');
    } finally {
      setIsConfiguring(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant={variant}
        size={size}
        onClick={handleApplyConfig}
        disabled={isConfiguring}
        className="flex items-center gap-1.5"
      >
        {isConfiguring ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Database className="h-4 w-4" />
        )}
        Apply Realtime Config
      </Button>
      
      {showStatus && <RealtimeStatus />}
    </div>
  );
};

export default RealtimeConfigButton;
